import classNames from 'classnames';
import React, {useEffect} from 'react';

/**
 * This is a ONE OFF eslint disable in order to have a single source of truth for datadog configs between
 * the app and weave folders. This is the shortest path to get us there and enable more teams to get consistent
 * datadog information. PLEASE DO NOT REPEAT THIS PATTERN UNLESS ABSOLUTELY NECESSARY.
 */
/* eslint-disable-next-line wandb/no-relative-imports-of-files-outside-workspace-root */
import {useDatadogRum} from '../../../../../app/src/util/datadog/hooks';
import {IconInfo} from '../../../components/Icon';
import {Tailwind} from '../../../components/Tailwind';

type ErrorMessage = {
  panelID?: string;
  panelViewType?: string;
  mediaType?: string;
  metaInfo?: Record<string, number | string | boolean>; // any additional information useful for segmentation in Datadog
} & (
  | {
      message: React.ReactChild;
      logErrorMessage: string;
    }
  | {message: string}
);

type PanelErrorProps = {
  className?: string;
} & ErrorMessage;

const PanelError: React.FC<PanelErrorProps> = React.memo(props => {
  const datadogRum = useDatadogRum();

  useEffect(() => {
    // HACK: There are race conditions in data loading (particularly with line plots) that cause PanelError to be
    // imperceptibly mounted on screen before the `loading` state is set to `true`. We only care if
    // the PanelError is rendered for more than `timeout` milliseconds.
    const timeout = setTimeout(() => {
      datadogRum.addAction('panel_error_rendered', {
        ...props.metaInfo,
        message:
          typeof props.message !== 'string' && 'logErrorMessage' in props
            ? props.logErrorMessage
            : props.message,
        panelID: props.panelID, // used for datadog de-duping of errors since virtualized panels will often re-render when scrolling
        panelViewType: props.panelViewType,
        mediaType: props.mediaType,
        // @ts-ignore - GIT_TAG is set in window.CONFIG in the app
        gitTag: window.CONFIG?.GIT_TAG,
      });
    }, 50);

    return () => {
      clearTimeout(timeout);
    };
  }, [props, datadogRum]);

  return (
    <div
      className={classNames('panel-error', props.className)}
      data-test="panel-error">
      <Tailwind>
        <IconInfo width={24} height={24} className="m-auto mb-4" />
        <div>{props.message}</div>
      </Tailwind>
    </div>
  );
});
export default PanelError;
